import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { AddRole } from 'components/Settings/Components/RolesManagement/components/addRole';

const AddRolePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.roleManagement.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader
                    title={settingsConfig.roleManagement.title}
                    subTitle={'Assign privileges & users'}
                    isBackArrow={true}
                />
            </HeaderWrapper>
            <MainContent>
                <AddRole />
            </MainContent>
        </PageContainer>
    );
};

export default AddRolePage;
